var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{attrs:{"xs12":"","sm6":"","d-flex":""}},[_c('v-select',{attrs:{"items":_vm.brands,"label":"Bandeira","item-text":"title","item-value":"business","return-object":"","prepend-icon":"credit_card"},model:{value:(_vm.cardBrand),callback:function ($$v) {_vm.cardBrand=$$v},expression:"cardBrand"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }